import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
//Patient 
import PatientDashBoardPage from '../app/patient/pages/PatientDashBoardPage'
import PatientSearchPage from '../app/patient/pages/PatientSearchPage'
import PatientListPage from '../app/patient/pages/PatientListPage'
import PatientDetailsPage from '../app/patient/pages/PatientDetailsPage'
import PatientAccountPage from '../app/patient/pages/PatientAccountPage'




function PatientRoutes() {
  return (
    <Routes>
        {/* Patient */}
        <Route path="/patient/dashboard" element={<PatientDashBoardPage/>}></Route>
        <Route path="/patient/search" element={<PatientSearchPage/>}></Route>
        <Route path="/patient/list" element={<PatientListPage/>}></Route>
        <Route path="/patient/details/:patientId" element={<PatientDetailsPage/>}></Route>
        <Route path="/patient/accounts/:patientId" element={<PatientAccountPage />}></Route>
          
    </Routes>
  )
}

export default PatientRoutes